import React, { useEffect, useState } from 'react';

import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row, 
  UncontrolledTooltip
} from 'reactstrap';

const positionMap = { left: 'flex-start', center: 'center', right: 'flex-end' };

export default function FormButton({ deleteComponent, rowId, colId, attributes, setAttributes, autoOpen = false }) {
  const [btnText, setBtnText] = useState(attributes ? attributes.btnText : 'Enviar');
  const [fontColor, setFontColor] = useState(attributes ? attributes.fontColor : '#fff');
  const [btnColor, setBtnColor] = useState(attributes ? attributes.btnColor : '#007bff');
  const [btnPosition, setBtnPosition] = useState(attributes ? attributes.btnPosition || 'center' : 'center');

  // Edit Modal
  const [editModal, setEditModal] = useState(false);

  useEffect(() => {
    if (autoOpen) setEditModal(true);
  }, []);

  useEffect(() => {
    if (!attributes) {
      setAttributes({
        rowId,
        colId,
        attributes: {
          inputName: 'Botao de envio',
          btnText: 'Enviar',
          fontColor: '#fff',
          btnColor: '#007bff',
          btnPosition: 'center',
        },
      });
    }
  }, [rowId, colId, setAttributes, attributes]);

  const submitForm = (e) => {
    e.preventDefault();
    setAttributes({
      rowId,
      colId,
      attributes: { btnText, fontColor, btnColor, btnPosition, inputName: 'Botao de envio' },
    });
    setEditModal(false);
  };

  return (
    <div className="custom-input-container" id="updload-component">
      <Modal
        size="lg"
        isOpen={editModal}
        toggle={() => setEditModal(!editModal)}
        centered
      >
        <ModalHeader toggle={() => setEditModal(false)}>
          Configurar Botão
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <Form>
                <FormGroup className="input-margin-btm">
                  <Label htmlFor="edit-input-text" className="form-label">
                    Texto do Botão
                  </Label>
                  <Input
                    id="edit-input-text"
                    className="form-control"
                    type="text"
                    value={btnText}
                    onChange={({ target }) => setBtnText(target.value)}
                  />
                </FormGroup>
                <FormGroup className="input-margin-btm">
                  <div style={{display: 'flex'}}>
                    <Label htmlFor="edit-input-btnColor" className="form-label">
                      Cor do texto
                    </Label>
                    <div>
                      <div className="show-tips" id="btn-input-tip">
                        <span>?</span>
                      </div>
                      <UncontrolledTooltip style={{ backgroundColor: '#6f42c1' }} placement="right" target="btn-input-tip">
                        RGB, HEX ou nome da cor em inglês
                      </UncontrolledTooltip>
                    </div>
                  </div>
                  <Input
                    id="edit-input-btnColor"
                    className="form-control"
                    type="text"
                    value={fontColor}
                    onChange={({ target }) => setFontColor(target.value)}
                  />
                </FormGroup>
                <FormGroup className="input-margin-btm">
                  <div style={{display: 'flex'}}>
                    <Label htmlFor="edit-input-btnColor" className="form-label">
                      Cor do botão
                    </Label>
                    <div>
                      <div className="show-tips" id="btn-input-tip">
                        <span>?</span>
                      </div>
                      <UncontrolledTooltip style={{ backgroundColor: '#6f42c1' }} placement="right" target="btn-input-tip">
                        RGB, HEX ou nome da cor em inglês
                      </UncontrolledTooltip>
                    </div>
                  </div>
                  <Input
                    id="edit-input-btnColor"
                    className="form-control"
                    type="text"
                    value={btnColor}
                    onChange={({ target }) => setBtnColor(target.value)}
                  />
                </FormGroup>
                <FormGroup className="input-margin-btm">
                  <Label htmlFor="edit-input-btnPosition" className="form-label">
                    Posição do botão
                  </Label>
                  <Input
                    id="edit-input-btnPosition"
                    className="form-control"
                    type="select"
                    value={btnPosition}
                    onChange={({ target }) => setBtnPosition(target.value)}
                  >
                    <option value="left">Esquerda</option>
                    <option value="center">Centro</option>
                    <option value="right">Direita</option>
                  </Input>
                </FormGroup>
              </Form>
            </Col>
            <Col style={{borderLeft: '1px solid gray'}}>
              <div style={{width: '100%', display: 'flex', justifyContent: positionMap[btnPosition] || 'flex-end'}}>
                <Button
                  style={{
                    backgroundColor: btnColor,
                  }}
                >
                  <span style={{color: fontColor}}>{btnText}</span>
                </Button>
              </div>
            </Col>
          </Row>
          <div className="save-btn-form-container">
            <Button
              color="success"
              className="btn btn-success waves-effect waves-light save-btn-form"
              onClick={submitForm}
            >
              Salvar
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <div className="displayed-config-container">
        <div style={{width: '100%', display: 'flex', justifyContent: positionMap[btnPosition] || 'flex-end'}}>
          <Button
            className="displayed-label"
            style={{
              backgroundColor: btnColor,
            }}
          >
            <span style={{color: fontColor}}>{btnText}</span>
          </Button>
        </div>
        <div className="config-form-icon">
          <span
            className="mdi mdi-cog-outline"
            onClick={() => setEditModal(!editModal)}
          />
        </div>
      </div>
    </div>
  )
}
